import classNames from "classnames";
import "./index.scss";

interface IProps {
  theme?: "light" | "dark";
  style?: string;
  onClick?: () => void;
  isDisable?: boolean;
}

export const NavLeftArrowOnbForm = ({
  theme,
  style,
  onClick,
  isDisable,
}: IProps) => {
  return (
    <div
      onClick={onClick}
      className={classNames({ [`${style}`]: true }, "arrow-onb-form")}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="20"
        viewBox="0 0 13 20"
        fill="none"
      >
        <path
          d="M0.0341011 9.99943L12.0194 0.510698L11.9605 19.5621L0.0341011 9.99943Z"
          fill="#333333"
        />
      </svg>
    </div>
  );
};
